<input class="form-control user-name valid"
       [ngClass]="isError ? 'error-control': ''"
       name="UserName"
       type="text"
       autocomplete="username"
       data-val="true"
       prefix="+7 "
       [mask]="myMask"
       [showMaskTyped]="showMaskTyped"       
       aria-required="true"
       [placeholder]="myPlaceholder"
       (click)="MaskIn()"
       (focus)="MaskIn()"
       (blur)="MaskOut()"
       [(ngModel)]="phoneValue"
       [readonly]="readonly ? 'true' : false" />

